module.exports = __webpack_public_path__ + "static/media/ic-descuento.6ac2c853.svg";